var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"indexCrate"},[_c('Nav'),_c('div',{staticClass:"container-fluid",staticStyle:{"padding-inline":"100px","margin-top":"20px"}},[_c('router-view')],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }